export const FetchAdminLogin = async (data) => {
  const API_URL = process.env.REACT_APP_API_URL + "auth/admin/login";
  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (response.status === 200) {
      const resData = await response.json();
      console.log(resData )
      localStorage.setItem("token", resData.token);
      localStorage.setItem("role", resData.role)
      return true;
    } else {
      console.warn("Access token is missing in response");
      return false;
    }
  } catch (error) {
    console.error("FetchAdminLogin error:", error);
    return false;
  }
};

// دالة الحذف النهائي - يحذف الأدمن نهائياً من قاعدة البيانات والواجهة
export const deleteAdminApi = async (id) => {
  const token = localStorage.getItem("token");
  const API_URL = process.env.REACT_APP_API_URL + "admin/";
  const fullURL = API_URL + id;
  
  console.log("🔍 Delete Admin Debug Info:");
  console.log("- Admin ID:", id);
  console.log("- API_URL:", API_URL);
  console.log("- Full URL:", fullURL);
  console.log("- Token exists:", !!token);
  
  try {
    // محاولة DELETE أولاً
    console.log("🚀 Attempting DELETE request...");
    let response;
    
    try {
      response = await fetch(fullURL, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });

      console.log("- DELETE Response status:", response.status);
      console.log("- DELETE Response ok:", response.ok);
    } catch (deleteError) {
      console.error("❌ DELETE request failed:", deleteError);
      response = { status: 404, ok: false };
    }

    // إذا فشل DELETE (404)، جرب PUT كحل مؤقت
    if (response.status === 404 || !response.ok) {
      console.log("🔄 DELETE failed, trying PUT method...");
      
      try {
        response = await fetch(fullURL, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ 
            isDeleted: true,
            hardDelete: true,
            deleteAdmin: true,
            permanentDelete: true
          })
        });

        console.log("- PUT Response status:", response.status);
        console.log("- PUT Response ok:", response.ok);
      } catch (putError) {
        console.error("❌ PUT request also failed:", putError);
        return {
          status: 500,
          ok: false,
          error: "Both DELETE and PUT requests failed"
        };
      }
    }

    if (response.ok) {
      const data = await response.json();
      console.log("✅ Success! Response data:", data);
      return {
        status: response.status,
        ok: response.ok,
        data: data
      };
    } else {
      console.error(`❌ Final request failed with status: ${response.status}`);
      // محاولة قراءة رسالة الخطأ من الاستجابة
      try {
        const errorData = await response.text();
        console.error("- Error response:", errorData);
      } catch (e) {
        console.error("- Could not read error response");
      }
      return {
        status: response.status,
        ok: response.ok
      };
    }
  } catch (error) {
    console.error("[deleteAdminApi] Unexpected error:", error);
    return {
      status: 500,
      ok: false,
      error: error.message
    };
  }
};

export const FetchAdminForgotPassword = async (data) => {
  const API_URL = process.env.REACT_APP_API_URL + "auth/admin/forgot-password";
  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (response.status === 200) {
      const data = await response.json();
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("FetchAdminLogin error:", error);
    return false;
  }
};